module.exports = __webpack_public_path__ + "img/arrow-top-right.2e9b0ad4.svg";